import { persist } from 'zustand/middleware'
import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { JWTToken, UserDto } from '@wwt/entities/api/search-response'

import { createSelectors } from '../createSelectors'

interface State {
	/**
	 * Current user
	 */
	user: UserDto | null
	/**
	 * Token for auth
	 */
	token: string | null
}

interface Actions {
	/**
	 * Set current token
	 * @param token - Token
	 */
	signIn: (token: JWTToken) => void
	/**
	 * Reset current token
	 */
	signOut: () => void
}

export const useSession = createSelectors(
	create<State & Actions>()(
		persist(
			set => ({
				user: null,
				token: null,

				signIn: ({ token }) => set({ token }),
				signOut: () => set({ user: null, token: null })
			}),
			{ name: 'session-v2' }
		),
		shallow
	)
)
